/*
 * East Crema Coffee — Custom JS
 * Scroll animations, enhanced hovers, subscription builder
 */

(function () {
  'use strict';

  /* ============================================================
     1. SCROLL REVEAL ANIMATIONS (IntersectionObserver)
     ============================================================ */

  function initScrollReveal() {
    var revealElements = document.querySelectorAll(
      '.ec-reveal, .ec-reveal--left, .ec-reveal--right, .ec-reveal--scale, .ec-stagger'
    );
    if (!revealElements.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    revealElements.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* Auto-tag sections for scroll reveal */
  function autoTagRevealElements() {
    document.querySelectorAll('.section--image .hero__content').forEach(function (el) {
      if (!el.classList.contains('ec-reveal')) {
        el.classList.add('ec-reveal');
      }
    });

    document.querySelectorAll('.section-icons .float-grid').forEach(function (el) {
      if (!el.classList.contains('ec-stagger')) {
        el.classList.add('ec-stagger');
      }
    });

    document.querySelectorAll('.section-blog .float-grid').forEach(function (el) {
      if (!el.classList.contains('ec-stagger')) {
        el.classList.add('ec-stagger');
      }
    });

    document.querySelectorAll('.section-columns .float-grid').forEach(function (el) {
      if (!el.classList.contains('ec-stagger')) {
        el.classList.add('ec-stagger');
      }
    });

    document.querySelectorAll('.sub-builder__header').forEach(function (el) {
      if (!el.classList.contains('ec-reveal')) {
        el.classList.add('ec-reveal');
      }
    });
  }


  /* ============================================================
     2. ENHANCED PRODUCT CARD HOVERS
     ============================================================ */

  function initProductHovers() {
    document.querySelectorAll('product-grid-item').forEach(function (item) {
      if (item.querySelector('.ec-hover-overlay')) return;

      var titleEl = item.querySelector('.product__grid__title');
      var title = titleEl ? titleEl.textContent.trim() : '';

      var priceEl = item.querySelector('.price');
      var price = priceEl ? priceEl.textContent.trim() : '';

      var cutlineEl = item.querySelector('.product__grid__cutline');
      var desc = cutlineEl ? cutlineEl.textContent.trim() : '';

      var link = item.querySelector('[data-grid-link]');
      var href = link ? link.getAttribute('href') : '#';

      var overlay = document.createElement('div');
      overlay.className = 'ec-hover-overlay';
      overlay.innerHTML =
        '<div class="ec-hover-overlay__view ec-hover-overlay__view--info">' +
          '<p class="ec-hover-overlay__title">' + title + '</p>' +
          '<p class="ec-hover-overlay__price">' + price + '</p>' +
          (desc ? '<p class="ec-hover-overlay__desc">' + desc + '</p>' : '') +
          '<button type="button" class="ec-hover-overlay__btn" data-ec-buy-trigger>Comprar</button>' +
          '<a href="' + href + '" class="ec-hover-overlay__link">Ver más</a>' +
        '</div>' +
        '<div class="ec-hover-overlay__view ec-hover-overlay__view--buy">' +
          '<p class="ec-hover-overlay__title">' + title + '</p>' +
          (desc ? '<p class="ec-hover-overlay__desc" style="margin-bottom:14px">' + desc + '</p>' : '') +
          '<div class="ec-hover-overlay__line" style="width:100%;max-width:260px;margin-bottom:18px"></div>' +
          '<div class="ec-qb__options-container"></div>' +
          '<div class="ec-qb__qty-row">' +
            '<span class="ec-qb__qty-label">Cantidad.</span>' +
            '<div class="ec-qb__qty-controls">' +
              '<button type="button" class="ec-qb__qty-btn" data-ec-qty-minus>−</button>' +
              '<span class="ec-qb__qty-value" data-ec-qty-display>1</span>' +
              '<button type="button" class="ec-qb__qty-btn" data-ec-qty-plus>+</button>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="ec-qb__add-btn" data-ec-add-cart>' +
            price + '  ·  Añadir al carrito' +
          '</button>' +
          '<a href="' + href + '" class="ec-hover-overlay__link" style="margin-top:12px">Ver más</a>' +
          '<span class="ec-qb__success" data-ec-success>✓ Añadido al carrito</span>' +
        '</div>';

      item.classList.add('ec-has-hover');
      item.appendChild(overlay);

      initQuickBuy(overlay, href);

      detectDarkImage(item);
      detectPngImage(item);

      initMobileTapHover(item);
    });
  }

  function initMobileTapHover(item) {
    if (!('ontouchstart' in window)) return;

    var link = item.querySelector('[data-grid-link]');
    if (!link) return;

    link.addEventListener('click', function (e) {
      if (window.innerWidth > 749) return;

      if (!item.classList.contains('ec-touch-active')) {
        e.preventDefault();
        e.stopPropagation();

        document.querySelectorAll('.ec-touch-active').forEach(function (el) {
          el.classList.remove('ec-touch-active');
        });

        item.classList.add('ec-touch-active');
      }
    });

    document.addEventListener('click', function (e) {
      if (!item.contains(e.target)) {
        item.classList.remove('ec-touch-active');
      }
    });
  }

  function detectPngImage(item) {
    var img = item.querySelector('product-grid-item-image.is-active img, product-grid-item-image img, img');
    if (!img) return;

    function check() {
      var src = (img.currentSrc || img.src || '').split('?')[0];
      if (src.toLowerCase().indexOf('.png') !== -1) {
        item.classList.add('ec-png-image');
      }
    }

    if (img.complete && img.naturalWidth > 0) {
      check();
    } else {
      img.addEventListener('load', check);
    }
  }

  function detectDarkImage(item) {
    if (item.classList.contains('ec-dark-checked')) return;
    item.classList.add('ec-dark-checked');

    var img = item.querySelector('product-grid-item-image.is-active img, product-grid-item-image img, img');
    if (!img) return;

    function check() {
      var src = img.currentSrc || img.src;
      if (!src || src.indexOf('data:') === 0) return;

      var smallSrc = src.replace(/width=\d+/, 'width=40');
      if (smallSrc === src) {
        smallSrc = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=40';
      }

      var probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        canvas.width = 40;
        canvas.height = 40;
        try {
          ctx.drawImage(probe, 0, 0, 40, 40);
          var data = ctx.getImageData(0, 0, 40, 40).data;
          var total = 0;
          var count = data.length / 4;
          for (var i = 0; i < data.length; i += 4) {
            total += data[i] * 0.299 + data[i + 1] * 0.587 + data[i + 2] * 0.114;
          }
          if (total / count < 120) {
            item.classList.add('ec-dark-image');
          }
        } catch (e) {}
      };
      probe.src = smallSrc;
    }

    if (img.complete && img.naturalWidth > 0) {
      check();
    } else {
      img.addEventListener('load', check);
    }
  }

  function initQuickBuy(overlay, productUrl) {
    var quantity = 1;
    var productData = null;
    var selectedVariantId = null;

    var buyTrigger = overlay.querySelector('[data-ec-buy-trigger]');
    var qtyDisplay = overlay.querySelector('[data-ec-qty-display]');
    var qtyMinus = overlay.querySelector('[data-ec-qty-minus]');
    var qtyPlus = overlay.querySelector('[data-ec-qty-plus]');
    var addBtn = overlay.querySelector('[data-ec-add-cart]');
    var successMsg = overlay.querySelector('[data-ec-success]');
    var optionsContainer = overlay.querySelector('.ec-qb__options-container');

    buyTrigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (overlay.classList.contains('is-buying')) return;

      var handle = extractHandle(productUrl);
      if (!handle) return;

      buyTrigger.textContent = 'Cargando...';

      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          productData = data;
          buildOptions(data);
          overlay.classList.add('is-buying');
        })
        .catch(function () {
          window.location.href = productUrl;
        });
    });

    function extractHandle(url) {
      var match = url.match(/\/products\/([^?#/]+)/);
      return match ? match[1] : null;
    }

    function buildOptions(data) {
      optionsContainer.innerHTML = '';

      var firstOpt = data.options[0];
      var firstOptName = typeof firstOpt === 'string' ? firstOpt : (firstOpt.name || firstOpt);
      if (data.variants.length === 1 && data.options.length === 1 && firstOptName === 'Title') {
        selectedVariantId = data.variants[0].id;
        updateAddBtnPrice();
        return;
      }

      data.options.forEach(function (rawOption, optIdx) {
        var optionName = typeof rawOption === 'string' ? rawOption : (rawOption.name || rawOption);
        var values = [];
        if (rawOption.values && Array.isArray(rawOption.values)) {
          values = rawOption.values;
        } else {
          data.variants.forEach(function (v) {
            var val = v.options[optIdx];
            if (values.indexOf(val) === -1) values.push(val);
          });
        }

        if (values.length === 1 && values[0] === 'Default Title') return;

        var row = document.createElement('div');
        row.className = 'ec-qb__option-row';

        var label = document.createElement('span');
        label.className = 'ec-qb__option-label';
        label.textContent = optionName + '.';

        var dropdown = document.createElement('div');
        dropdown.className = 'ec-qb__dropdown';
        dropdown.setAttribute('data-ec-option-index', optIdx);

        var toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'ec-qb__dropdown-toggle';
        toggle.textContent = values[0];
        toggle.setAttribute('data-ec-dropdown-value', values[0]);

        var list = document.createElement('div');
        list.className = 'ec-qb__dropdown-list';

        values.forEach(function (val) {
          var item = document.createElement('button');
          item.type = 'button';
          item.className = 'ec-qb__dropdown-item';
          if (val === values[0]) item.classList.add('is-selected');
          item.textContent = val;
          item.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            toggle.textContent = val;
            toggle.setAttribute('data-ec-dropdown-value', val);
            list.querySelectorAll('.ec-qb__dropdown-item').forEach(function (el) {
              el.classList.remove('is-selected');
            });
            item.classList.add('is-selected');
            dropdown.classList.remove('is-open');
            resolveVariant(data);
          });
          list.appendChild(item);
        });

        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var wasOpen = dropdown.classList.contains('is-open');
          optionsContainer.querySelectorAll('.ec-qb__dropdown.is-open').forEach(function (d) {
            d.classList.remove('is-open');
          });
          if (!wasOpen) dropdown.classList.add('is-open');
        });

        dropdown.appendChild(toggle);
        dropdown.appendChild(list);
        row.appendChild(label);
        row.appendChild(dropdown);
        optionsContainer.appendChild(row);
      });

      resolveVariant(data);
    }

    function resolveVariant(data) {
      var dropdowns = optionsContainer.querySelectorAll('.ec-qb__dropdown[data-ec-option-index]');
      var chosen = [];
      dropdowns.forEach(function (d) {
        var toggle = d.querySelector('.ec-qb__dropdown-toggle');
        chosen.push(toggle.getAttribute('data-ec-dropdown-value'));
      });

      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        var match = true;
        for (var j = 0; j < chosen.length; j++) {
          if (v.options[j] !== chosen[j]) { match = false; break; }
        }
        if (match) {
          selectedVariantId = v.id;
          updateAddBtnPrice(v);
          return;
        }
      }
      selectedVariantId = data.variants[0].id;
      updateAddBtnPrice(data.variants[0]);
    }

    function updateAddBtnPrice(variant) {
      if (!variant && productData) variant = productData.variants[0];
      if (!variant) return;

      var priceFormatted = formatMoney(variant.price);
      addBtn.textContent = priceFormatted + '  ·  Añadir al carrito';
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2).replace('.', ',');
      return amount + ' €';
    }

    qtyMinus.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (quantity > 1) {
        quantity--;
        qtyDisplay.textContent = quantity;
      }
    });

    qtyPlus.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      quantity++;
      qtyDisplay.textContent = quantity;
    });

    addBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (!selectedVariantId) return;

      addBtn.disabled = true;
      addBtn.textContent = 'Añadiendo...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: selectedVariantId,
          quantity: quantity
        })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          addBtn.textContent = '✓ Añadido';
          successMsg.classList.add('is-visible');
          setTimeout(function () {
            addBtn.disabled = false;
            successMsg.classList.remove('is-visible');
            var v = null;
            if (productData) {
              for (var i = 0; i < productData.variants.length; i++) {
                if (productData.variants[i].id === selectedVariantId) {
                  v = productData.variants[i]; break;
                }
              }
            }
            updateAddBtnPrice(v);
          }, 2000);
        })
        .catch(function () {
          addBtn.textContent = 'Error, inténtalo de nuevo';
          addBtn.disabled = false;
          setTimeout(function () {
            var v = null;
            if (productData) {
              for (var i = 0; i < productData.variants.length; i++) {
                if (productData.variants[i].id === selectedVariantId) {
                  v = productData.variants[i]; break;
                }
              }
            }
            updateAddBtnPrice(v);
          }, 2000);
        });
    });

    overlay.addEventListener('mouseleave', function () {
      setTimeout(function () {
        overlay.classList.remove('is-buying');
        quantity = 1;
        qtyDisplay.textContent = '1';
        successMsg.classList.remove('is-visible');
        buyTrigger.textContent = 'Comprar';
      }, 300);
    });
  }


  /* ============================================================
     3. SUBSCRIPTION WIZARD — logic moved to subscription-builder.liquid
     ============================================================ */


  /* ============================================================
     4. ANIMATED LINK UNDERLINES
     ============================================================ */

  function initAnimatedLinks() {
    document.querySelectorAll('.footer a, .subfooter a').forEach(function (link) {
      if (!link.classList.contains('ec-link-animated') && !link.querySelector('svg') && !link.querySelector('img')) {
        link.classList.add('ec-link-animated');
      }
    });
  }


  /* ============================================================
     INIT
     ============================================================ */

  function truncatePopoutToggle() {
    document.querySelectorAll('.product-section .select-popout__toggle').forEach(function(btn) {
      var svg = btn.querySelector('svg');
      var textNodes = [];
      btn.childNodes.forEach(function(n) {
        if (n !== svg && n.nodeType === Node.TEXT_NODE) textNodes.push(n);
        if (n !== svg && n.nodeType === Node.ELEMENT_NODE && !n.querySelector('svg')) textNodes.push(n);
      });
      textNodes.forEach(function(node) {
        var text = (node.textContent || '').trim();
        if (!text) return;
        var words = text.split(/\s+/);
        if (words.length > 5) {
          var truncated = words.slice(0, 5).join(' ');
          if (node.nodeType === Node.TEXT_NODE) {
            node.textContent = truncated;
          } else {
            node.textContent = truncated;
          }
        }
      });
    });
  }

  var _popoutObserver = new MutationObserver(function() { truncatePopoutToggle(); });

  function initPopoutTruncation() {
    truncatePopoutToggle();
    document.querySelectorAll('.product-section .select-popout').forEach(function(el) {
      _popoutObserver.observe(el, { childList: true, subtree: true, characterData: true });
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.ec-qb__dropdown')) {
      document.querySelectorAll('.ec-qb__dropdown.is-open').forEach(function (d) {
        d.classList.remove('is-open');
      });
    }
  });

  function initProductMobile() {
    if (window.innerWidth > 749) return;

    var wrapper = document.querySelector('.product-section .product__mobile--carousel');
    if (wrapper) {
      var mediaItems = wrapper.querySelectorAll('.product__media');
      if (mediaItems.length > 1) {
        wrapper.classList.add('has-multiple-images');
      }
    }
  }

  function initProductCollapsibles() {
    if (window.innerWidth > 749) return;
    var section = document.querySelector('.product-section');
    if (!section) return;

    var textBlocks = section.querySelectorAll('.product__block__text');
    textBlocks.forEach(function (block) {
      if (block.previousElementSibling && block.previousElementSibling.classList.contains('ec-collapse-toggle')) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ec-collapse-toggle';
      btn.textContent = 'Descripción';
      btn.addEventListener('click', function () {
        btn.classList.toggle('is-active');
        block.classList.toggle('is-expanded');
      });
      block.parentNode.insertBefore(btn, block);
    });

    var infoTable = section.querySelector('.ec-product-info-table');
    if (infoTable) {
      if (infoTable.previousElementSibling && infoTable.previousElementSibling.classList.contains('ec-collapse-toggle')) return;
      var btn2 = document.createElement('button');
      btn2.type = 'button';
      btn2.className = 'ec-collapse-toggle';
      btn2.textContent = 'Trazabilidad';
      btn2.setAttribute('data-ec-toggle', 'trazabilidad');
      btn2.addEventListener('click', function () {
        btn2.classList.toggle('is-active');
        infoTable.classList.toggle('is-expanded');
      });
      infoTable.parentNode.insertBefore(btn2, infoTable);
    }
  }

  function initProductPopouts() {
    var section = document.querySelector('.product-section');
    if (!section) return;

    function syncPopout(toggle) {
      var popout = toggle.closest('.select-popout');
      if (!popout) return;
      var list = popout.querySelector('.select-popout__list');
      if (!list) return;
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        list.style.cssText = 'opacity:1!important;visibility:visible!important;height:auto!important;pointer-events:auto!important;display:block!important;z-index:1001!important;';
        list.querySelectorAll('.select-popout__option').forEach(function (opt) {
          opt.style.setProperty('display', 'block', 'important');
        });
        list.querySelectorAll('.select-popout__item').forEach(function (li) {
          li.style.setProperty('height', 'auto', 'important');
        });
        toggle.style.borderRadius = '50px 50px 0 0';
        toggle.style.borderBottom = 'none';
      } else {
        list.style.cssText = '';
        list.querySelectorAll('.select-popout__option').forEach(function (opt) {
          opt.style.display = '';
        });
        list.querySelectorAll('.select-popout__item').forEach(function (li) {
          li.style.height = '';
        });
        toggle.style.borderRadius = '';
        toggle.style.borderBottom = '';
      }
    }

    function closeAll() {
      section.querySelectorAll('.select-popout__toggle[data-popout-toggle]').forEach(function (t) {
        var p = t.closest('.select-popout');
        if (!p) return;
        var l = p.querySelector('.select-popout__list');
        if (l) {
          l.style.cssText = '';
          l.querySelectorAll('.select-popout__option').forEach(function (opt) {
            opt.style.display = '';
          });
          l.querySelectorAll('.select-popout__item').forEach(function (li) {
            li.style.height = '';
          });
        }
        t.style.borderRadius = '';
        t.style.borderBottom = '';
      });
    }

    section.addEventListener('click', function (e) {
      var toggle = e.target.closest('.select-popout__toggle[data-popout-toggle]');
      if (toggle) {
        setTimeout(function () { syncPopout(toggle); }, 10);
        return;
      }
      var option = e.target.closest('.select-popout__option');
      if (option) {
        setTimeout(function () { closeAll(); }, 50);
        return;
      }
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.select-popout')) {
        closeAll();
      }
    });
  }

  function init() {
    autoTagRevealElements();
    initScrollReveal();
    initProductHovers();
    initAnimatedLinks();
    initPopoutTruncation();
    initProductMobile();
    initProductCollapsibles();
    initProductPopouts();
    initBackToBuy();
  }

  function initBackToBuy() {
    var bar = document.getElementById('ecBackToBuy');
    var btn = document.getElementById('ecBackToBuyBtn');
    var addBtn = document.querySelector('[data-add-to-cart]');
    if (!bar || !btn || !addBtn) return;

    var visible = false;

    function checkScroll() {
      var rect = addBtn.getBoundingClientRect();
      var shouldShow = rect.bottom < 0;
      if (shouldShow !== visible) {
        visible = shouldShow;
        if (visible) {
          bar.classList.add('is-visible');
          bar.setAttribute('aria-hidden', 'false');
        } else {
          bar.classList.remove('is-visible');
          bar.setAttribute('aria-hidden', 'true');
        }
      }
    }

    btn.addEventListener('click', function () {
      addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    window.addEventListener('scroll', checkScroll, { passive: true });
    checkScroll();
  }

  function initCourseDateMerge() {
    if (window.innerWidth > 749) return;
    document.querySelectorAll('.ec-flow__course-row').forEach(function(row) {
      if (row.dataset.dateMerged) return;
      var dateCol = row.querySelector('.ec-flow__course-date-col');
      var duration = row.querySelector('.ec-flow__course-duration');
      if (!dateCol || !duration) return;
      var day = dateCol.querySelector('.ec-flow__course-day');
      var month = dateCol.querySelector('.ec-flow__course-month-abbr');
      if (!day || !month) return;
      var dateStr = day.textContent.trim() + ' ' + month.textContent.trim();
      duration.textContent = dateStr + '  ·  ' + duration.textContent;
      dateCol.style.display = 'none';
      row.dataset.dateMerged = 'true';
    });
  }

  var flowObserver = new MutationObserver(function() { initCourseDateMerge(); });
  var flowEl = document.querySelector('[data-cursos-flow]');
  if (flowEl) flowObserver.observe(flowEl, { childList: true, subtree: true, attributes: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(); initCourseDateMerge(); });
  } else {
    init();
    initCourseDateMerge();
  }

  /* ============================================================
     SEAL SUBSCRIPTIONS — Translate & restyle widget
     ============================================================ */
  var _sealBusy = false;

  function fixSealWidget() {
    if (_sealBusy) return;
    _sealBusy = true;

    var translations = {
      'Purchase options': 'Opciones de compra',
      'One-time purchase': 'Compra única',
      'Powered by Seal Subscriptions': '',
      'SAVE': 'AHORRA',
      'Interval select': 'Selecciona frecuencia'
    };

    document.querySelectorAll('.sls-purchase-options-label, .sls-selling-plan-group-name').forEach(function(el) {
      var txt = el.textContent.trim();
      if (translations[txt] !== undefined) el.textContent = translations[txt];
    });

    var badgeStyles = {
      'display': 'inline-block',
      'font-family': '"IBM Plex Mono", monospace',
      'font-size': '11px',
      'font-weight': '400',
      'letter-spacing': '0.08em',
      'text-transform': 'uppercase',
      'background': '#000f9f',
      'color': '#fff',
      'padding': '6px 14px',
      'border-radius': '50px',
      'margin': '0 0 0 8px',
      'line-height': '1',
      'vertical-align': 'middle',
      'border': 'none',
      'box-shadow': 'none',
      'background-image': 'none',
      'clip-path': 'none',
      '-webkit-clip-path': 'none',
      'position': 'static',
      'overflow': 'visible',
      'width': 'auto',
      'height': 'auto',
      'transform': 'none',
      'filter': 'none',
      '-webkit-filter': 'none',
      'mask': 'none',
      '-webkit-mask': 'none',
      'animation': 'none',
      'transition': 'none',
      'float': 'none',
      'shape-outside': 'none',
      '-webkit-shape-outside': 'none'
    };

    document.querySelectorAll('.sls-savings-badge').forEach(function(badge) {
      var txt = badge.textContent.trim();
      if (txt.indexOf('SAVE') !== -1) txt = txt.replace('SAVE', 'AHORRA');

      badge.innerHTML = txt;

      Object.keys(badgeStyles).forEach(function(prop) {
        badge.style.setProperty(prop, badgeStyles[prop], 'important');
      });
    });

    document.querySelectorAll('.sls-powered-by').forEach(function(el) {
      el.style.setProperty('display', 'none', 'important');
    });

    var container = document.querySelector('.sls-option-container');
    if (container) {
      container.style.setProperty('display', 'flex', 'important');
      container.style.setProperty('flex-direction', 'column', 'important');
      container.style.setProperty('gap', '2px', 'important');
      container.style.setProperty('border', 'none', 'important');
      container.style.setProperty('overflow', 'visible', 'important');
      container.style.setProperty('border-radius', '0', 'important');
      container.style.setProperty('width', '100%', 'important');
      container.style.setProperty('padding', '0', 'important');
      container.style.setProperty('margin', '0', 'important');
    }

    var rows = document.querySelectorAll('.sls-option-container > .seal-row');
    rows.forEach(function(row, i) {
      row.style.setProperty('display', 'block', 'important');
      row.style.setProperty('border', '1.5px solid #0a0a09', 'important');
      row.style.setProperty('border-radius', '16px', 'important');
      row.style.setProperty('overflow', 'hidden', 'important');
      row.style.setProperty('padding', '4px 0', 'important');
      row.style.setProperty('margin-top', '0', 'important');
      row.style.setProperty('margin-left', '0', 'important');
      row.style.setProperty('margin-right', '0', 'important');
      row.style.setProperty('margin-bottom', i < rows.length - 1 ? '2px' : '0', 'important');
      row.style.setProperty('width', '100%', 'important');
      row.style.setProperty('box-sizing', 'border-box', 'important');
    });

    document.querySelectorAll('.sls-option-container .seal-col').forEach(function(col) {
      col.style.setProperty('display', 'block', 'important');
      col.style.setProperty('margin', '0', 'important');
      col.style.setProperty('padding', '0', 'important');
    });

    document.querySelectorAll('.sls-select.seal-tight').forEach(function(sel) {
      sel.style.setProperty('border', '1.5px solid #0a0a09', 'important');
      sel.style.setProperty('color', '#0a0a09', 'important');
      sel.style.setProperty('font-weight', '500', 'important');
    });

    document.querySelectorAll('.seal-ac-selling-plan-description, .sls-selling-plan-group-description').forEach(function(el) {
      el.style.setProperty('color', '#0a0a09', 'important');
      el.style.setProperty('font-weight', '500', 'important');
    });

    _sealBusy = false;
  }

  var _sealDebounce = null;
  var sealObserver = new MutationObserver(function() {
    if (_sealDebounce) clearTimeout(_sealDebounce);
    _sealDebounce = setTimeout(function() {
      if (document.querySelector('.sls-option-container')) fixSealWidget();
      _sealDebounce = null;
    }, 80);
  });
  sealObserver.observe(document.body, { childList: true, subtree: true });

  [500, 1000, 2000, 3500, 6000, 10000].forEach(function(delay) {
    setTimeout(function() {
      if (document.querySelector('.sls-option-container')) fixSealWidget();
    }, delay);
  });

  document.addEventListener('shopify:section:load', function () {
    autoTagRevealElements();
    initScrollReveal();
    initProductHovers();
    initAnimatedLinks();
    initPopoutTruncation();
  });

  document.addEventListener('theme:related-products:added', function () {
    initProductHovers();
  });

  function openExternalLinksInNewTab() {
    var host = location.hostname;
    document.querySelectorAll('a[href]').forEach(function(link) {
      try {
        var url = new URL(link.href, location.origin);
        if (url.hostname && url.hostname !== host && url.protocol.indexOf('http') === 0) {
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'noopener noreferrer');
        }
      } catch (e) {}
    });
  }

  openExternalLinksInNewTab();

  var externalLinksObserver = new MutationObserver(function() {
    openExternalLinksInNewTab();
  });
  externalLinksObserver.observe(document.body, { childList: true, subtree: true });

})();
